export default __webpack_public_path__ + "static/media/driverand.0e599091.png";